import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EventForPlanningDto } from '../../../../shared/models/calendar/event-for-planning.dto';
import { GetLeadEventsFilter } from '../../../../shared/models/calendar/get-lead-events.filter';
import { Company } from '../../../../shared/models/company/company.model';
import { CalendarComuService } from '../../../../shared/services/calendar/calendar-comu.service';
import { CalendarService } from '../../../../shared/services/calendar/calendar.service';
import { CompanyService } from '../../../../shared/services/company/company.service';
import { MyLeadRouteGenerator } from './../../../../shared/generator/mylead-route.generator';

@Component({
  selector: 'ngx-planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningComponent implements OnInit {
  getLeadEventsFilter: GetLeadEventsFilter;
  showAllHoursFlag: any;
  events: EventForPlanningDto[];
  companies: Company[];
  multipleCompanies = false;
  constructor(private readonly calendarService: CalendarService,
    private readonly calendarComuService: CalendarComuService,
    private readonly myLeadRouteGenerator: MyLeadRouteGenerator,
    private readonly cdr: ChangeDetectorRef,
    private readonly companyService: CompanyService) {
    this.getLeadEventsFilter = new GetLeadEventsFilter();
    // this.getPlanningEvent(this.getLeadEventsFilter);
    this.events = [];
  }
  ngOnInit(): void {
    this.companyService.getUserLoggedCompanies$().subscribe(res => {
      this.companies = res.companies;
      if (this.companies.length > 1) {
        this.multipleCompanies = true;
      }
    });
    this.calendarComuService.searchPlanningDayEvents.subscribe(res => {
      this.getLeadEventsFilter = res;
      this.getPlanningEvent(this.getLeadEventsFilter);
    });
  }

  setUrlLead(leadId, companyId) {
    return this.myLeadRouteGenerator.generateWithCompany(leadId, companyId);
  }

  isToday(dateEventRaw) {
    const dateEvent = new Date(parseInt(dateEventRaw, 10)).getDate();
    return dateEvent === new Date(Date.now()).getDate();
  }

  isPast(dateEventRaw) {
    return Date.now() > parseInt(dateEventRaw, 10);
  }

  notAttended(dateEventRaw, dateEventLead, dateEventInit, leadStatus) {
    if (leadStatus !== 'archived' && leadStatus !== 'closed') {
      return Date.now() > parseInt(dateEventRaw, 10) && Date.now() > (parseInt(dateEventLead, 10)) && parseInt(dateEventInit, 10) === (parseInt(dateEventLead, 10));
    }
  }
  private getPlanningEvent(getLeadEventsFilter: GetLeadEventsFilter) {
    getLeadEventsFilter.isPlanningDay = true;
    this.calendarService.getEventsForDay$(getLeadEventsFilter).subscribe(events => {
      this.events = events;
      this.cdr.detectChanges();
    });
  }

}
